/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Steps_Finish_TitleInputs */

const en_road_dude_steps_finish_title = /** @type {(inputs: Road_Dude_Steps_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the delivery`)
};

const zh_road_dude_steps_finish_title = /** @type {(inputs: Road_Dude_Steps_Finish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查对白与停顿`)
};

/**
* | output |
* | --- |
* | "Review the delivery" |
*
* @param {Road_Dude_Steps_Finish_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_steps_finish_title = /** @type {((inputs?: Road_Dude_Steps_Finish_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Steps_Finish_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_steps_finish_title(inputs)
	return zh_road_dude_steps_finish_title(inputs)
});
export { road_dude_steps_finish_title as "road_dude.steps.finish.title" }